module.exports = __webpack_public_path__ + "static/media/MajooCRM16.b3314025.png";